import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const consult = async (token: string) => {
  return await dponetAPI.get(`/integration_partners/consult/${token}`)
}

export default { consult }
